import React from "react";

const ReturnChargeIcon = (props: any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_3394_99528)">
          <mask
            id="mask0_3394_99528"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <path d="M24 0H0V24H24V0Z" fill={props?.color ?? "#464646"}/>
          </mask>
          <g mask="url(#mask0_3394_99528)">
            <path
              d="M13.4186 14.2563C13.167 14.2563 12.9402 14.2069 12.7389 14.1077C12.539 14.0065 12.373 13.8635 12.2418 13.6791C12.1119 13.4948 12.0268 13.2756 11.9868 13.0216L12.3617 12.9473C12.4219 13.2252 12.5484 13.443 12.7418 13.602C12.9351 13.7586 13.166 13.8372 13.4341 13.8372C13.6105 13.8372 13.769 13.8043 13.9092 13.7389C14.0494 13.6716 14.159 13.5761 14.2389 13.4534C14.3189 13.3301 14.3589 13.1843 14.3589 13.0159C14.3589 12.9049 14.3424 12.8104 14.309 12.7332C14.2756 12.6537 14.2314 12.5884 14.1764 12.5366C14.1213 12.4849 14.0616 12.4426 13.9962 12.4087C13.9313 12.3729 13.8678 12.3442 13.8062 12.3226L12.8942 11.9981C12.7841 11.9604 12.6825 11.9129 12.5894 11.8551C12.4962 11.7953 12.4144 11.7252 12.3443 11.6439C12.2761 11.5606 12.2225 11.4633 12.1844 11.3522C12.1463 11.2412 12.127 11.1142 12.127 10.9712C12.127 10.729 12.1801 10.5197 12.2869 10.3433C12.3937 10.1669 12.5395 10.031 12.7244 9.9355C12.9092 9.84048 13.1199 9.79345 13.3565 9.7958C13.5964 9.7958 13.8104 9.8466 13.999 9.94773C14.1891 10.0489 14.3457 10.1937 14.4689 10.3823C14.5922 10.5686 14.674 10.7902 14.714 11.046L14.3292 11.1293C14.3043 10.943 14.2469 10.7812 14.1566 10.6443C14.0668 10.5075 13.9515 10.4021 13.8118 10.3287C13.6736 10.2535 13.5212 10.2144 13.3546 10.2125C13.1928 10.2125 13.0489 10.2455 12.9224 10.3109C12.7973 10.3744 12.6985 10.4618 12.6251 10.5728C12.5517 10.6839 12.515 10.8109 12.515 10.9538C12.515 11.0987 12.5484 11.2149 12.6152 11.3019C12.6834 11.3894 12.7667 11.4576 12.865 11.5075C12.9652 11.5569 13.0616 11.5978 13.1547 11.6293L13.8593 11.8762C13.9327 11.9002 14.0183 11.9346 14.1166 11.9802C14.2168 12.0239 14.3133 12.0874 14.4064 12.1707C14.5014 12.2521 14.5795 12.3593 14.6411 12.4919C14.7027 12.6251 14.7338 12.7934 14.7338 12.9981C14.7338 13.1966 14.7004 13.3739 14.6336 13.531C14.5687 13.6876 14.476 13.8198 14.3561 13.9266C14.2375 14.0338 14.0988 14.1152 13.9388 14.1707C13.7803 14.2276 13.6072 14.2563 13.4186 14.2563Z"
              fill={props?.color ?? "#464646"}
              stroke={props?.color ?? "#464646"}
              strokeWidth="0.0470367"
              strokeMiterlimit="10"
            />
          </g>
          <mask
            id="mask1_3394_99528"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <path d="M24 0H0V24H24V0Z" fill={props?.color ?? "#464646"} />
          </mask>
          <g mask="url(#mask1_3394_99528)">
            <path
              d="M9.01587 14.167V9.88144H10.4053C10.4401 9.88144 10.4797 9.88332 10.5229 9.88755C10.5681 9.88944 10.6128 9.89555 10.6579 9.90543C10.8461 9.93929 11.0055 10.0174 11.1353 10.1406C11.267 10.2615 11.3663 10.4144 11.4326 10.5987C11.5008 10.7831 11.5352 10.9877 11.5352 11.2116C11.5352 11.5352 11.4637 11.8156 11.3202 12.0536C11.1767 12.2916 10.9721 12.4416 10.7054 12.5028L10.578 12.5385H9.38323V14.1665H9.01587V14.167ZM11.1951 14.167L10.4853 12.4228L10.8376 12.262L11.6175 14.1665H11.1951V14.167ZM9.38323 12.1223H10.3955C10.4256 12.1223 10.4604 12.1204 10.5003 12.1162C10.5403 12.1119 10.5794 12.1053 10.6179 12.0955C10.7412 12.0639 10.8418 12.0033 10.9204 11.9139C11.0003 11.8245 11.0596 11.7187 11.0977 11.5955C11.1377 11.4722 11.1579 11.3443 11.1579 11.2116C11.1579 11.079 11.1377 10.9506 11.0977 10.8278C11.0596 10.7027 11.0003 10.5959 10.9204 10.5066C10.8423 10.4172 10.7412 10.357 10.6179 10.325C10.5798 10.3151 10.5403 10.309 10.5003 10.3071C10.4604 10.3034 10.4256 10.301 10.3955 10.301H9.38323V12.1223Z"
              fill={props?.color ?? "#464646"}
              stroke={props?.color ?? "#464646"}
              strokeWidth="0.0470367"
              strokeMiterlimit="10"
            />
          </g>
          <mask
            id="mask2_3394_99528"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <path d="M24 0H0V24H24V0Z" fill={props?.color ?? "#464646"} />
          </mask>
          <g mask="url(#mask2_3394_99528)">
            <path
              d="M11.874 6.48953C14.9314 6.48953 17.4102 8.96836 17.4102 12.0257C17.4102 15.0831 14.9314 17.562 11.874 17.562C8.81663 17.562 6.33779 15.0831 6.33779 12.0257C6.33779 8.96836 8.81663 6.48953 11.874 6.48953ZM11.874 5.73694C10.1943 5.73694 8.61484 6.39122 7.42716 7.5789C6.23949 8.76657 5.58521 10.3461 5.58521 12.0257C5.58521 13.7054 6.23949 15.2849 7.42716 16.4726C8.61484 17.6603 10.1943 18.3145 11.874 18.3145C13.5537 18.3145 15.1332 17.6603 16.3209 16.4726C17.5085 15.2849 18.1628 13.7054 18.1628 12.0257C18.1628 10.3461 17.5085 8.76657 16.3209 7.5789C15.1332 6.39122 13.5542 5.73694 11.874 5.73694Z"
              fill={props?.color ?? "#464646"}
            />
          </g>
          <mask
            id="mask3_3394_99528"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <path d="M24 0H0V24H24V0Z" fill={props?.color ?? "#464646"} />
          </mask>
          <g mask="url(#mask3_3394_99528)">
            <path
              d="M11.8743 5.09072C15.7035 5.09072 18.8075 8.19467 18.8075 12.0239C18.8075 15.8532 15.7035 18.9571 11.8743 18.9571C8.04501 18.9571 4.94106 15.8532 4.94106 12.0239C4.94106 8.19467 8.04548 5.09072 11.8743 5.09072ZM11.8743 4.33813C10.8371 4.33813 9.83053 4.54133 8.88227 4.94256C7.96693 5.32967 7.1452 5.88376 6.43965 6.58931C5.7341 7.29486 5.18001 8.11659 4.7929 9.03193C4.39215 9.98019 4.18848 10.9868 4.18848 12.0239C4.18848 13.0611 4.39167 14.0677 4.7929 15.0159C5.18001 15.9313 5.7341 16.753 6.43965 17.4585C7.1452 18.1641 7.96693 18.7182 8.88227 19.1053C9.83053 19.5061 10.8371 19.7097 11.8743 19.7097C12.9114 19.7097 13.918 19.5065 14.8663 19.1053C15.7816 18.7182 16.6033 18.1641 17.3089 17.4585C18.0144 16.753 18.5685 15.9313 18.9556 15.0159C19.3564 14.0677 19.5601 13.0611 19.5601 12.0239C19.5601 10.9868 19.3569 9.98019 18.9556 9.03193C18.5685 8.11659 18.0144 7.29486 17.3089 6.58931C16.6033 5.88376 15.7816 5.32967 14.8663 4.94256C13.9185 4.5418 12.9119 4.33813 11.8743 4.33813Z"
              fill={props?.color ?? "#464646"}
            />
          </g>
          <mask
            id="mask4_3394_99528"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <path d="M24 0H0V24H24V0Z" fill="white" />
          </mask>
          <g mask="url(#mask4_3394_99528)">
            <path
              d="M2.96385 5.87348C3.46338 5.26483 4.02312 4.70839 4.6346 4.21168C6.72961 2.50895 9.30158 1.59973 11.9709 1.59973C12.3204 1.59973 12.6708 1.61525 13.0226 1.64677C15.7611 1.89089 18.2809 3.06963 20.207 4.98967L20.1111 4.17828C20.105 4.1256 20.1097 4.07198 20.1257 4.02118C20.1417 3.97038 20.168 3.92381 20.2033 3.88383C20.2385 3.84385 20.2818 3.81234 20.3307 3.7907C20.3792 3.76906 20.4319 3.75777 20.485 3.75777C20.5772 3.75777 20.6661 3.79164 20.7348 3.85279C20.8035 3.91394 20.8477 3.99813 20.8585 4.08985L21.0927 6.06916C21.0998 6.12748 21.0927 6.18722 21.0725 6.24225C21.0523 6.29776 21.0194 6.34761 20.9766 6.3876C20.9333 6.42805 20.8815 6.45721 20.8251 6.47414C20.7687 6.49061 20.7089 6.4939 20.6511 6.48308L18.723 6.12701C18.6247 6.10867 18.5377 6.05269 18.4813 5.97038C18.4248 5.88807 18.4032 5.78694 18.421 5.68863C18.4389 5.59032 18.4954 5.50378 18.5777 5.44686C18.66 5.39042 18.7611 5.36878 18.8594 5.38665L19.6957 5.54094C15.7639 1.59221 9.50713 1.22062 5.1092 4.79493C4.53723 5.25966 4.01324 5.78035 3.5457 6.34997C3.51418 6.38807 3.47561 6.42005 3.43234 6.4431C3.38859 6.46662 3.34109 6.48073 3.2917 6.4859C3.24278 6.49061 3.19292 6.4859 3.14541 6.47179C3.09791 6.45768 3.05416 6.43416 3.01606 6.40265C2.93892 6.33915 2.89 6.2479 2.88013 6.14865C2.87072 6.04987 2.90035 5.95062 2.96385 5.87348Z"
              fill={props?.color ?? "#464646"}
              stroke={props?.color ?? "#464646"}
              strokeWidth="0.0470367"
              strokeMiterlimit="10"
            />
          </g>
          <mask
            id="mask5_3394_99528"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <path d="M24 0H0V24H24V0Z" fill="white" />
          </mask>
          <g mask="url(#mask5_3394_99528)">
            <path
              d="M21.0361 18.1265C20.5366 18.7351 19.9768 19.2916 19.3654 19.7883C17.2703 21.491 14.6984 22.4002 12.029 22.4002C11.6796 22.4002 11.3291 22.3847 10.9773 22.3532C8.23883 22.1086 5.71907 20.9303 3.79292 19.0103L3.88888 19.8217C3.89499 19.8744 3.89029 19.928 3.87429 19.9788C3.8583 20.0296 3.83196 20.0762 3.79668 20.1161C3.76141 20.1561 3.71813 20.1876 3.66921 20.2093C3.62077 20.2309 3.56809 20.2422 3.51493 20.2422C3.42274 20.2422 3.33384 20.2083 3.26517 20.1472C3.1965 20.086 3.15228 20.0018 3.14146 19.9101L2.90769 17.9308C2.90063 17.8725 2.90769 17.8128 2.92792 17.7577C2.94814 17.7022 2.98107 17.6524 3.02387 17.6124C3.06714 17.5719 3.11888 17.5428 3.17533 17.5258C3.23177 17.5094 3.29151 17.5061 3.34936 17.5169L5.2774 17.873C5.37571 17.8913 5.46272 17.9473 5.51917 18.0296C5.57561 18.1119 5.59725 18.213 5.57937 18.3113C5.5615 18.4097 5.50506 18.4962 5.42274 18.5531C5.34043 18.6096 5.2393 18.6312 5.14099 18.6133L4.30468 18.459C8.23648 22.4078 14.4933 22.7794 18.8912 19.205C19.4632 18.7403 19.9872 18.2196 20.4547 17.65C20.4862 17.6119 20.5248 17.5799 20.5681 17.5569C20.6118 17.5334 20.6593 17.5192 20.7087 17.5141C20.7576 17.5094 20.8075 17.5141 20.855 17.5282C20.9025 17.5423 20.9463 17.5658 20.9844 17.5973C21.0615 17.6608 21.1104 17.7521 21.1203 17.8513C21.1292 17.9501 21.0991 18.0493 21.0361 18.1265Z"
              fill={props?.color ?? "#464646"}
              stroke={props?.color ?? "#464646"}
              strokeWidth="0.0470367"
              strokeMiterlimit="10"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_3394_99528">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default ReturnChargeIcon;
